import React from 'react';
import { Zap, Users, Rocket, Clock, Award, HeartHandshake } from 'lucide-react';
import './WhyChooseUs.css';

const reasons = [
  {
    icon: <Zap size={32} />,
    title: 'Agile Development',
    description: 'We follow agile methodologies for faster delivery and better results.'
  },
  {
    icon: <Users size={32} />,
    title: 'Experienced Team',
    description: 'Senior engineers with 5+ years of experience in cutting-edge technologies.'
  },
  {
    icon: <Rocket size={32} />,
    title: 'Startup-Friendly',
    description: 'Flexible engagement models tailored for startups and enterprises.'
  },
  {
    icon: <Clock size={32} />,
    title: 'Fast Delivery',
    description: 'We deliver MVPs in a short time period without compromising quality.'
  },
  {
    icon: <Award size={32} />,
    title: 'Quality Assured',
    description: 'ISO-certified processes and rigorous testing for every project.'
  },
  {
    icon: <HeartHandshake size={32} />,
    title: 'Long-term Support',
    description: 'We build lasting partnerships with ongoing maintenance and support.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us section">
      <div className="container">
        <h2 className="section-title">Why Choose <span className="gold-text">Us</span></h2>
        <p className="section-subtitle">
          We combine technical excellence with business understanding to deliver exceptional results.
        </p>

        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-icon">{reason.icon}</div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;